import request from '../utils/request'

// 10.1
// 登录
export function postLoginMcn(data) {
  return request({
    url: 'api/mcn/user/login',
    method: 'post',
    data: data
  })
}

// 个人信息
export function postUserInfoMcn(data) {
  return request({
    url: 'api/mcn/user/info',
    method: 'post',
    data: data
  })
}

// 图片上传
export function postMcnImageUpload(data) {
  return request({
    url: 'api/mcn/image/upload',
    method: 'post',
    data: data
  })
}

// 个人信息修改
export function postMcnUserUpdate(data) {
  return request({
    url: 'api/mcn/user/update',
    method: 'post',
    data: data
  })
}

// 邀请网红入驻
export function postInviteBabe(data) {
  return request({
    url: 'api/mcn/babe/invite_babe',
    method: 'post',
    data: data
  })
}

// 旗下网红列表
export function postMcnBabeList(data) {
  return request({
    url: 'api/mcn/babe/lists',
    method: 'post',
    data: data
  })
}

// 收入详情
export function postMcnBabeIncome(data) {
  return request({
    url: 'api/mcn/babe/income',
    method: 'post',
    data: data
  })
}

// 网红个人信息详情
export function postMcnBabeInfo(data) {
  return request({
    url: 'api/mcn/babe/info',
    method: 'post',
    data: data
  })
}

// 网红个人NFT列表
export function postMcnBabeNftList(data) {
  return request({
    url: 'api/mcn/babe/nfts',
    method: 'post',
    data: data
  })
}

// 10.6
// 退出登录
export function postMcnUserLogout(data) {
  return request({
    url: 'api/mcn/user/logout',
    method: 'post',
    data: data
  })
}

// 邀请列表
export function postMcnBabeInviteList(data) {
  return request({
    url: 'api/mcn/babe/invite_lists',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/mcn.js